import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import nl from './locales/nl.json'

const availableLocales = ['en', 'nl'];

function detectUserLocale(): string {
  const lang = navigator.language.split('-')[0];
  return availableLocales.includes(lang) ? lang : 'en';
}

export const i18n = createI18n({
  legacy: false,
  locale: detectUserLocale(),
  fallbackLocale: 'en',
  messages: { en, nl },
});
